/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LogoutRouteImport } from './routes/logout'
import { Route as ErrorRouteImport } from './routes/error'
import { Route as _publicRouteImport } from './routes/__public'
import { Route as _authRouteImport } from './routes/__auth'
import { Route as R503RouteImport } from './routes/503'
import { Route as R404RouteImport } from './routes/404'
import { Route as SplatRouteImport } from './routes/$'
import { Route as _authIndexRouteImport } from './routes/__auth/index'
import { Route as _publicRegisterRouteImport } from './routes/__public/register'
import { Route as _publicLoginRouteImport } from './routes/__public/login'
import { Route as _publicForgotPasswordRouteImport } from './routes/__public/forgot-password'
import { Route as _authMyAccountRouteImport } from './routes/__auth/my-account'
import { Route as _authEditPasswordRouteImport } from './routes/__auth/edit-password'
import { Route as _publicEmailValidatedIndexRouteImport } from './routes/__public/email-validated.index'
import { Route as _publicReturnResetPasswordStateRouteImport } from './routes/__public/return-reset-password.$state'
import { Route as _publicResetPasswordIdRouteImport } from './routes/__public/reset-password.$id'
import { Route as _publicEmailValidateIdRouteImport } from './routes/__public/email-validate.$id'
import { Route as _authRequestHistoryRequestIdRouteImport } from './routes/__auth/request-history.$requestId'
import { Route as _authFirstRegistrationProcessIdRouteImport } from './routes/__auth/first-registration.$processId'
import { Route as _authTaskRequestIdTaskIdRouteImport } from './routes/__auth/task.$requestId.$taskId'
import { Route as _authSignatureRequestIdTaskIdRouteImport } from './routes/__auth/signature.$requestId.$taskId'

const LogoutRoute = LogoutRouteImport.update({
  id: '/logout',
  path: '/logout',
  getParentRoute: () => rootRouteImport,
} as any)
const ErrorRoute = ErrorRouteImport.update({
  id: '/error',
  path: '/error',
  getParentRoute: () => rootRouteImport,
} as any)
const _publicRoute = _publicRouteImport.update({
  id: '/__public',
  getParentRoute: () => rootRouteImport,
} as any)
const _authRoute = _authRouteImport.update({
  id: '/__auth',
  getParentRoute: () => rootRouteImport,
} as any)
const R503Route = R503RouteImport.update({
  id: '/503',
  path: '/503',
  getParentRoute: () => rootRouteImport,
} as any)
const R404Route = R404RouteImport.update({
  id: '/404',
  path: '/404',
  getParentRoute: () => rootRouteImport,
} as any)
const SplatRoute = SplatRouteImport.update({
  id: '/$',
  path: '/$',
  getParentRoute: () => rootRouteImport,
} as any)
const _authIndexRoute = _authIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => _authRoute,
} as any)
const _publicRegisterRoute = _publicRegisterRouteImport.update({
  id: '/register',
  path: '/register',
  getParentRoute: () => _publicRoute,
} as any)
const _publicLoginRoute = _publicLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => _publicRoute,
} as any)
const _publicForgotPasswordRoute = _publicForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => _publicRoute,
} as any)
const _authMyAccountRoute = _authMyAccountRouteImport.update({
  id: '/my-account',
  path: '/my-account',
  getParentRoute: () => _authRoute,
} as any)
const _authEditPasswordRoute = _authEditPasswordRouteImport.update({
  id: '/edit-password',
  path: '/edit-password',
  getParentRoute: () => _authRoute,
} as any)
const _publicEmailValidatedIndexRoute =
  _publicEmailValidatedIndexRouteImport.update({
    id: '/email-validated/',
    path: '/email-validated/',
    getParentRoute: () => _publicRoute,
  } as any)
const _publicReturnResetPasswordStateRoute =
  _publicReturnResetPasswordStateRouteImport.update({
    id: '/return-reset-password/$state',
    path: '/return-reset-password/$state',
    getParentRoute: () => _publicRoute,
  } as any)
const _publicResetPasswordIdRoute = _publicResetPasswordIdRouteImport.update({
  id: '/reset-password/$id',
  path: '/reset-password/$id',
  getParentRoute: () => _publicRoute,
} as any)
const _publicEmailValidateIdRoute = _publicEmailValidateIdRouteImport.update({
  id: '/email-validate/$id',
  path: '/email-validate/$id',
  getParentRoute: () => _publicRoute,
} as any)
const _authRequestHistoryRequestIdRoute =
  _authRequestHistoryRequestIdRouteImport.update({
    id: '/request-history/$requestId',
    path: '/request-history/$requestId',
    getParentRoute: () => _authRoute,
  } as any)
const _authFirstRegistrationProcessIdRoute =
  _authFirstRegistrationProcessIdRouteImport.update({
    id: '/first-registration/$processId',
    path: '/first-registration/$processId',
    getParentRoute: () => _authRoute,
  } as any)
const _authTaskRequestIdTaskIdRoute =
  _authTaskRequestIdTaskIdRouteImport.update({
    id: '/task/$requestId/$taskId',
    path: '/task/$requestId/$taskId',
    getParentRoute: () => _authRoute,
  } as any)
const _authSignatureRequestIdTaskIdRoute =
  _authSignatureRequestIdTaskIdRouteImport.update({
    id: '/signature/$requestId/$taskId',
    path: '/signature/$requestId/$taskId',
    getParentRoute: () => _authRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/$': typeof SplatRoute
  '/404': typeof R404Route
  '/503': typeof R503Route
  '/error': typeof ErrorRoute
  '/logout': typeof LogoutRoute
  '/edit-password': typeof _authEditPasswordRoute
  '/my-account': typeof _authMyAccountRoute
  '/forgot-password': typeof _publicForgotPasswordRoute
  '/login': typeof _publicLoginRoute
  '/register': typeof _publicRegisterRoute
  '/': typeof _authIndexRoute
  '/first-registration/$processId': typeof _authFirstRegistrationProcessIdRoute
  '/request-history/$requestId': typeof _authRequestHistoryRequestIdRoute
  '/email-validate/$id': typeof _publicEmailValidateIdRoute
  '/reset-password/$id': typeof _publicResetPasswordIdRoute
  '/return-reset-password/$state': typeof _publicReturnResetPasswordStateRoute
  '/email-validated': typeof _publicEmailValidatedIndexRoute
  '/signature/$requestId/$taskId': typeof _authSignatureRequestIdTaskIdRoute
  '/task/$requestId/$taskId': typeof _authTaskRequestIdTaskIdRoute
}
export interface FileRoutesByTo {
  '/$': typeof SplatRoute
  '/404': typeof R404Route
  '/503': typeof R503Route
  '/error': typeof ErrorRoute
  '/logout': typeof LogoutRoute
  '/edit-password': typeof _authEditPasswordRoute
  '/my-account': typeof _authMyAccountRoute
  '/forgot-password': typeof _publicForgotPasswordRoute
  '/login': typeof _publicLoginRoute
  '/register': typeof _publicRegisterRoute
  '/': typeof _authIndexRoute
  '/first-registration/$processId': typeof _authFirstRegistrationProcessIdRoute
  '/request-history/$requestId': typeof _authRequestHistoryRequestIdRoute
  '/email-validate/$id': typeof _publicEmailValidateIdRoute
  '/reset-password/$id': typeof _publicResetPasswordIdRoute
  '/return-reset-password/$state': typeof _publicReturnResetPasswordStateRoute
  '/email-validated': typeof _publicEmailValidatedIndexRoute
  '/signature/$requestId/$taskId': typeof _authSignatureRequestIdTaskIdRoute
  '/task/$requestId/$taskId': typeof _authTaskRequestIdTaskIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/$': typeof SplatRoute
  '/404': typeof R404Route
  '/503': typeof R503Route
  '/__auth': typeof _authRouteWithChildren
  '/__public': typeof _publicRouteWithChildren
  '/error': typeof ErrorRoute
  '/logout': typeof LogoutRoute
  '/__auth/edit-password': typeof _authEditPasswordRoute
  '/__auth/my-account': typeof _authMyAccountRoute
  '/__public/forgot-password': typeof _publicForgotPasswordRoute
  '/__public/login': typeof _publicLoginRoute
  '/__public/register': typeof _publicRegisterRoute
  '/__auth/': typeof _authIndexRoute
  '/__auth/first-registration/$processId': typeof _authFirstRegistrationProcessIdRoute
  '/__auth/request-history/$requestId': typeof _authRequestHistoryRequestIdRoute
  '/__public/email-validate/$id': typeof _publicEmailValidateIdRoute
  '/__public/reset-password/$id': typeof _publicResetPasswordIdRoute
  '/__public/return-reset-password/$state': typeof _publicReturnResetPasswordStateRoute
  '/__public/email-validated/': typeof _publicEmailValidatedIndexRoute
  '/__auth/signature/$requestId/$taskId': typeof _authSignatureRequestIdTaskIdRoute
  '/__auth/task/$requestId/$taskId': typeof _authTaskRequestIdTaskIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/$'
    | '/404'
    | '/503'
    | '/error'
    | '/logout'
    | '/edit-password'
    | '/my-account'
    | '/forgot-password'
    | '/login'
    | '/register'
    | '/'
    | '/first-registration/$processId'
    | '/request-history/$requestId'
    | '/email-validate/$id'
    | '/reset-password/$id'
    | '/return-reset-password/$state'
    | '/email-validated'
    | '/signature/$requestId/$taskId'
    | '/task/$requestId/$taskId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/$'
    | '/404'
    | '/503'
    | '/error'
    | '/logout'
    | '/edit-password'
    | '/my-account'
    | '/forgot-password'
    | '/login'
    | '/register'
    | '/'
    | '/first-registration/$processId'
    | '/request-history/$requestId'
    | '/email-validate/$id'
    | '/reset-password/$id'
    | '/return-reset-password/$state'
    | '/email-validated'
    | '/signature/$requestId/$taskId'
    | '/task/$requestId/$taskId'
  id:
    | '__root__'
    | '/$'
    | '/404'
    | '/503'
    | '/__auth'
    | '/__public'
    | '/error'
    | '/logout'
    | '/__auth/edit-password'
    | '/__auth/my-account'
    | '/__public/forgot-password'
    | '/__public/login'
    | '/__public/register'
    | '/__auth/'
    | '/__auth/first-registration/$processId'
    | '/__auth/request-history/$requestId'
    | '/__public/email-validate/$id'
    | '/__public/reset-password/$id'
    | '/__public/return-reset-password/$state'
    | '/__public/email-validated/'
    | '/__auth/signature/$requestId/$taskId'
    | '/__auth/task/$requestId/$taskId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  SplatRoute: typeof SplatRoute
  R404Route: typeof R404Route
  R503Route: typeof R503Route
  _authRoute: typeof _authRouteWithChildren
  _publicRoute: typeof _publicRouteWithChildren
  ErrorRoute: typeof ErrorRoute
  LogoutRoute: typeof LogoutRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/logout': {
      id: '/logout'
      path: '/logout'
      fullPath: '/logout'
      preLoaderRoute: typeof LogoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/error': {
      id: '/error'
      path: '/error'
      fullPath: '/error'
      preLoaderRoute: typeof ErrorRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/__public': {
      id: '/__public'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof _publicRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/__auth': {
      id: '/__auth'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof _authRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/503': {
      id: '/503'
      path: '/503'
      fullPath: '/503'
      preLoaderRoute: typeof R503RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/404': {
      id: '/404'
      path: '/404'
      fullPath: '/404'
      preLoaderRoute: typeof R404RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$': {
      id: '/$'
      path: '/$'
      fullPath: '/$'
      preLoaderRoute: typeof SplatRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/__auth/': {
      id: '/__auth/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof _authIndexRouteImport
      parentRoute: typeof _authRoute
    }
    '/__public/register': {
      id: '/__public/register'
      path: '/register'
      fullPath: '/register'
      preLoaderRoute: typeof _publicRegisterRouteImport
      parentRoute: typeof _publicRoute
    }
    '/__public/login': {
      id: '/__public/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof _publicLoginRouteImport
      parentRoute: typeof _publicRoute
    }
    '/__public/forgot-password': {
      id: '/__public/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof _publicForgotPasswordRouteImport
      parentRoute: typeof _publicRoute
    }
    '/__auth/my-account': {
      id: '/__auth/my-account'
      path: '/my-account'
      fullPath: '/my-account'
      preLoaderRoute: typeof _authMyAccountRouteImport
      parentRoute: typeof _authRoute
    }
    '/__auth/edit-password': {
      id: '/__auth/edit-password'
      path: '/edit-password'
      fullPath: '/edit-password'
      preLoaderRoute: typeof _authEditPasswordRouteImport
      parentRoute: typeof _authRoute
    }
    '/__public/email-validated/': {
      id: '/__public/email-validated/'
      path: '/email-validated'
      fullPath: '/email-validated'
      preLoaderRoute: typeof _publicEmailValidatedIndexRouteImport
      parentRoute: typeof _publicRoute
    }
    '/__public/return-reset-password/$state': {
      id: '/__public/return-reset-password/$state'
      path: '/return-reset-password/$state'
      fullPath: '/return-reset-password/$state'
      preLoaderRoute: typeof _publicReturnResetPasswordStateRouteImport
      parentRoute: typeof _publicRoute
    }
    '/__public/reset-password/$id': {
      id: '/__public/reset-password/$id'
      path: '/reset-password/$id'
      fullPath: '/reset-password/$id'
      preLoaderRoute: typeof _publicResetPasswordIdRouteImport
      parentRoute: typeof _publicRoute
    }
    '/__public/email-validate/$id': {
      id: '/__public/email-validate/$id'
      path: '/email-validate/$id'
      fullPath: '/email-validate/$id'
      preLoaderRoute: typeof _publicEmailValidateIdRouteImport
      parentRoute: typeof _publicRoute
    }
    '/__auth/request-history/$requestId': {
      id: '/__auth/request-history/$requestId'
      path: '/request-history/$requestId'
      fullPath: '/request-history/$requestId'
      preLoaderRoute: typeof _authRequestHistoryRequestIdRouteImport
      parentRoute: typeof _authRoute
    }
    '/__auth/first-registration/$processId': {
      id: '/__auth/first-registration/$processId'
      path: '/first-registration/$processId'
      fullPath: '/first-registration/$processId'
      preLoaderRoute: typeof _authFirstRegistrationProcessIdRouteImport
      parentRoute: typeof _authRoute
    }
    '/__auth/task/$requestId/$taskId': {
      id: '/__auth/task/$requestId/$taskId'
      path: '/task/$requestId/$taskId'
      fullPath: '/task/$requestId/$taskId'
      preLoaderRoute: typeof _authTaskRequestIdTaskIdRouteImport
      parentRoute: typeof _authRoute
    }
    '/__auth/signature/$requestId/$taskId': {
      id: '/__auth/signature/$requestId/$taskId'
      path: '/signature/$requestId/$taskId'
      fullPath: '/signature/$requestId/$taskId'
      preLoaderRoute: typeof _authSignatureRequestIdTaskIdRouteImport
      parentRoute: typeof _authRoute
    }
  }
}

interface _authRouteChildren {
  _authEditPasswordRoute: typeof _authEditPasswordRoute
  _authMyAccountRoute: typeof _authMyAccountRoute
  _authIndexRoute: typeof _authIndexRoute
  _authFirstRegistrationProcessIdRoute: typeof _authFirstRegistrationProcessIdRoute
  _authRequestHistoryRequestIdRoute: typeof _authRequestHistoryRequestIdRoute
  _authSignatureRequestIdTaskIdRoute: typeof _authSignatureRequestIdTaskIdRoute
  _authTaskRequestIdTaskIdRoute: typeof _authTaskRequestIdTaskIdRoute
}

const _authRouteChildren: _authRouteChildren = {
  _authEditPasswordRoute: _authEditPasswordRoute,
  _authMyAccountRoute: _authMyAccountRoute,
  _authIndexRoute: _authIndexRoute,
  _authFirstRegistrationProcessIdRoute: _authFirstRegistrationProcessIdRoute,
  _authRequestHistoryRequestIdRoute: _authRequestHistoryRequestIdRoute,
  _authSignatureRequestIdTaskIdRoute: _authSignatureRequestIdTaskIdRoute,
  _authTaskRequestIdTaskIdRoute: _authTaskRequestIdTaskIdRoute,
}

const _authRouteWithChildren = _authRoute._addFileChildren(_authRouteChildren)

interface _publicRouteChildren {
  _publicForgotPasswordRoute: typeof _publicForgotPasswordRoute
  _publicLoginRoute: typeof _publicLoginRoute
  _publicRegisterRoute: typeof _publicRegisterRoute
  _publicEmailValidateIdRoute: typeof _publicEmailValidateIdRoute
  _publicResetPasswordIdRoute: typeof _publicResetPasswordIdRoute
  _publicReturnResetPasswordStateRoute: typeof _publicReturnResetPasswordStateRoute
  _publicEmailValidatedIndexRoute: typeof _publicEmailValidatedIndexRoute
}

const _publicRouteChildren: _publicRouteChildren = {
  _publicForgotPasswordRoute: _publicForgotPasswordRoute,
  _publicLoginRoute: _publicLoginRoute,
  _publicRegisterRoute: _publicRegisterRoute,
  _publicEmailValidateIdRoute: _publicEmailValidateIdRoute,
  _publicResetPasswordIdRoute: _publicResetPasswordIdRoute,
  _publicReturnResetPasswordStateRoute: _publicReturnResetPasswordStateRoute,
  _publicEmailValidatedIndexRoute: _publicEmailValidatedIndexRoute,
}

const _publicRouteWithChildren =
  _publicRoute._addFileChildren(_publicRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  SplatRoute: SplatRoute,
  R404Route: R404Route,
  R503Route: R503Route,
  _authRoute: _authRouteWithChildren,
  _publicRoute: _publicRouteWithChildren,
  ErrorRoute: ErrorRoute,
  LogoutRoute: LogoutRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
